<template></template>

<script>
import { h } from 'vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

export default {
    name: 'imc_toast',
    data() {
        return {
            string_err: 'IMC ERR',
            string_title: 'IMC_ERR TITLE',
            variant: 'success',
            position: 'top-right',
            autoClose: 3800,
        }
    },
    created() {
        EventBus.$on('show_toast', (e = {}) => {
            // payload: { err, title, type, position, autoHideDelay }
            this.string_err = e.err ?? this.string_err
            this.string_title = e.title ?? this.string_title
            this.variant = e.type ?? this.variant
            this.position = e.position ?? this.position
            this.autoClose = e.autoHideDelay ?? this.autoClose
            this.makeToast()
        })
    },
    methods: {
        makeToast() {
            // map bootstrap 'danger' -> toastify 'error'
            const typeMap = { danger: 'error', error: 'error', success: 'success', warning: 'warning', info: 'info' }
            const type = typeMap[this.variant] || 'default'
            
            const content = h('div', { class: 'imc-toast' }, [
                h('div', { class: 'imc-toast__title' }, this.string_title || 'IMC'),
                h('div', { class: 'imc-toast__body' }, this.string_err || '...'),
            ])
            
            toast(content, {
                type,
                position: this.position, // 'top-right' | 'top-center' | ...
                autoClose: this.autoClose, // мс
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                theme: 'colored',
            })
        },
    },
}
</script>

<style scoped>
.imc-toast__title {
    font-weight: 600;
    margin-bottom: 2px;
}
.imc-toast__body {
    opacity: .9;
    font-size: 0.95rem;
    line-height: 1.25rem;
}
</style>